// extracted by mini-css-extract-plugin
export default {"Footer":"FooterCopyright_Footer__ydfVD","Copyright":"FooterCopyright_Copyright__H7zdE"};